import React, { useState } from 'react';
import SAEChart from './components/Charts/SAEChart';
import SAEForm from './components/Widgets/SAEForm';
import { Col, Row } from 'react-bootstrap';

export function SAESearch() {

    const [formData, setFormData] = useState({
        filter: 'ic2025',
        toggle: 'bachelors',
        institution: ''
    });
    const [counts, setCounts] = useState({});

    const handleFormChange = (newData, collectAnalytics = true) => {
        setFormData(newData);

        let analytics = { ...newData };
        delete analytics['filter'];
        if (analytics['institution'] === '') {
            delete analytics['institution'];
        }
        if (analytics['state'] === '') {
            delete analytics['institution'];
        }
        if (collectAnalytics) {
            dataLayer.push({
                'event': 'carnegieSAECForm',
                'value': JSON.stringify(analytics)
            });
            console.log('SAE Form Data:', analytics);
        }
    };

    return (
        <Row>
            <Col lg={3} className="p-5 institute-filter">
                <SAEForm formData={formData} onFormChange={handleFormChange} counts={counts} />
                <Col xs={12} sm={12}>
                    <p className='mt-4'><strong>Note:</strong> Some Institutional Classifications include colleges with a mix of award levels. This includes:</p>
                    <ul>
                        <li>Special Focus: Arts, Music, and Design</li>
                        <li>Special Focus: Business</li>
                        <li>Special Focus: Nursing</li>
                        <li>Special Focus: Other Health Professions</li>
                    </ul><p>For those cases, institutions will display on the Special Focus Mixed Levels tab, and the measure for higher earnings is set at 1.25.</p>
                </Col>
            </Col>
            <Col lg={9} className="p-5">
                <SAEChart formData={formData} legend={false} setCounts={setCounts} />
            </Col>
        </Row>
    );
}

